// Date utilities

// Robustly parse various date formats to a millisecond timestamp.
// Supports ISO strings, epoch seconds/milliseconds, numbers, and safe fallbacks.
export const parseDateToMs = (value: unknown): number => {
  if (value === null || value === undefined) return -Infinity;
  if (typeof value === "number") {
    return value < 1e12 ? value * 1000 : value;
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (/^\d+$/.test(trimmed)) {
      const num = Number(trimmed);
      return num < 1e12 ? num * 1000 : num;
    }
    const ms = Date.parse(trimmed);
    return Number.isNaN(ms) ? -Infinity : ms;
  }
  const ms = Date.parse(String(value));
  return Number.isNaN(ms) ? -Infinity : ms;
};
